var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { toWorkspaceViewModel } from '#models';
import { WorkspacesKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
export function useWorkspaceById(workspaceId) {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const query = useQuery({
        queryKey: WorkspacesKeyFactory.byWorkspace(workspaceId),
        queryFn: () => lucidSdk.workspacesManagement().getWorkspace(workspaceId),
        enabled: canFetchWorkspaceData(workspaceLoginStatus),
        networkMode: 'always',
        select: toWorkspaceViewModel,
    });
    return { query };
}
_react_refresh_temp_1(useWorkspaceById, "SbdBs5aIiaIFSyvdNoid7gLUPcs=", false, () => [useLucidSdk, useGetWorkspaceLoginStatus, useQuery]);
